<template>
    <v-radio
        :value="value"
        color="var(--theme-color-one)"
        on-icon="radio_button_checked"
        off-icon="radio_button_unchecked"
    >
      <template v-slot:label>
        <slot></slot>
      </template>
    </v-radio>
</template>

<script>
export default {
  name: "RadioItem",
  props: {
    value: {
      default: ''
    }
  }
}
</script>

<style scoped>

</style>